import React, { useContext, useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { Link } from "react-router-dom";
import moment from "moment"

import {FirebaseContext} from '../services/Firebase/Context'

const Vehicule = ({ id, numberPlate, customerName, customerBusiness, status, comments, createdAt, createdBy }) => {
  const { db } = useContext(FirebaseContext)
  const [user, setUser] = useState({})
  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, "users", createdBy), (doc) => setUser({id: doc.id, ...doc.data()}));
    return () => unsubscribe()
  }, [db, createdBy])

  return (
    <Link to={`/app/interventions/${id}`}>
      <div className="shadow-lg rounded-2xl p-4 bg-white dark:bg-gray-700 w-full">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <div className="flex flex-col">
                <span className="font-bold text-md text-black dark:text-white ml-2">
                  {numberPlate}
                </span>
                <span className="text-sm text-gray-500 dark:text-white ml-2">
                  {customerName} { customerBusiness &&  <span className='text-yellow-600'>Pro</span> }
                </span>
              </div>
            </div>
            <div className="flex items-center">
              { status === "new" && <span className="px-2 py-1 flex items-center font-semibold text-xs rounded-md text-yellow-700 bg-yellow-50">
                EN ATTENTE
              </span>}
              { status === "pending" && <span className="px-2 py-1 flex items-center font-semibold text-xs rounded-md text-gray-700 bg-gray-50">
                EN COURS
              </span>}
            </div>
          </div>
          <div className="flex items-center justify-start mb-4 space-x-12">
            {comments}
          </div>
          <div className="flex items-center justify-start mt-4 space-x-4">
            <span className="px-2 py-1 flex items-center text-xs rounded-md font-semibold text-blue-500 bg-blue-50">
              {user && user.firstName} {user && user.lastName && user.lastName.charAt(0)}
            </span>
            <span className="px-2 py-1 flex items-center text-xs rounded-md text-gray-600 font-semibold bg-gray-200">
              {createdAt && moment(createdAt.toDate()).calendar()}
            </span>
          </div>
      </div>
    </Link>
  );
}

export default Vehicule